import { uniqueId } from 'lodash'
import { useContext, useEffect, useMemo, useState } from 'react'
import { useUnmount } from 'react-use'
import { fontFamily } from 'utils'
import { TextStyle } from '../../../../types'
import LayerOptions from '../../components/layer-actions'
import { UgeEditorContext } from '../../contexts/editor'
import { UgeLayersContext } from '../../contexts/layers'
import { CaptionLayerProps } from '../../types'
import { Caption, Captions, StyleOptions } from './style'

const DEFAULT_CAPTION_STYLE: TextStyle = {
    align: 'center',
    color: '#ffffff',
    fontFamily: fontFamily('giphy'),
    fontSize: 24,
    fontWeight: 'normal',
    strokeColor: '#000000',
}

const CaptionsEditor = () => {
    const { captions, addLayer, layers, setLayers } = useContext(UgeLayersContext)
    const { activeEditorProps } = useContext(UgeEditorContext)
    const [activeCaptionId, setActiveCaptionId] = useState<string | undefined>(activeEditorProps?.layerId)
    const reversedCaptions = useMemo(() => [...captions].reverse(), [captions])

    useEffect(() => {
        if (!captions.length) {
            addLayer({
                id: uniqueId('uge-caption-'),
                type: 'caption',
                props: {
                    text: '',
                    textStyle: DEFAULT_CAPTION_STYLE,
                },
            })
        }
    }, [captions])

    useEffect(() => {
        if (activeEditorProps?.layerId) {
            setActiveCaptionId(activeEditorProps.layerId)
        }
    }, [activeEditorProps?.layerId])

    useUnmount(() => {
        setLayers(
            layers.filter((layer) => {
                if (layer.type === 'caption' && !(layer.props as CaptionLayerProps).text) {
                    return false
                }

                return true
            })
        )
    })

    return (
        <Captions>
            {reversedCaptions.map((caption, i) => (
                <Caption
                    active={caption.id === activeCaptionId || captions.length === 1}
                    caption={caption}
                    key={caption.id}
                    showAdd={i === captions.length - 1}
                    onExpand={setActiveCaptionId}
                >
                    <StyleOptions caption={caption} defaultFontSize={DEFAULT_CAPTION_STYLE.fontSize} />
                    <LayerOptions disabled={!caption.props.text} layer={caption} />
                </Caption>
            ))}
        </Captions>
    )
}

export default CaptionsEditor
